var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiniLogoCloudtime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "",
    height: 75,
    viewBox: "0 0 106 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.9083 10.1529C71.9083 10.1529 54.8627 -5.94097 31.5676 10.1528C31.5676 10.1528 20.6505 18.1996 19.5527 32.3823C19.5527 32.3823 1.18456 33.2736 3.14671 55.8459C3.14671 55.8459 4.14075 73.1651 25.2835 71.6568C25.2835 71.6568 33.936 73.1651 51.4311 54.7319L64.4055 40.155V49.5387",
    stroke: "#8EC3DD",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4498 71.7427H79.1521C79.1521 71.7427 95.2382 72.4969 101.626 55.6919C101.626 55.6919 108.29 35.4824 92.2648 23.922C92.2648 23.922 84.2865 17.5977 69.3413 21.6596C69.3413 21.6596 64.0427 23.4421 57.1708 28.5325C53.1255 31.5233 48.5443 39.0668 44.1705 44.6628V35.5019",
    stroke: "#F26246",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniLogoCloudtime);
export default __webpack_public_path__ + "static/media/mini_logo_cloudtime.218bdbdd192a0e857a1c678ce782e297.svg";
export { ForwardRef as ReactComponent };